import type { TFunction } from "react-i18next";

// The self-reported acquisition channels JuisciGPT offers ("How did you hear
// about us?"). Mirrors the API `AcquisitionChannel` Prisma enum (minus "other",
// which no card offers) — keep in sync.
export const ACQUISITION_CHANNELS = [
  "social_media",
  "word_of_mouth",
  "app_store",
  "search_engine",
  "medical_conference",
  "email_newsletter",
  "healthcare_professional",
] as const;

export type AcquisitionChannelValue = (typeof ACQUISITION_CHANNELS)[number];

export function acquisitionChannelLabel(
  t: TFunction,
  value: AcquisitionChannelValue
): string {
  switch (value) {
    case "social_media":
      return t("Social Media");
    case "word_of_mouth":
      return t("Word of Mouth");
    case "app_store":
      return t("App Store / Google Play");
    case "search_engine":
      return t("Search Engine");
    case "medical_conference":
      return t("Medical Conference / Event");
    case "email_newsletter":
      return t("Email / Newsletter");
    case "healthcare_professional":
      return t("Healthcare Professional");
    default:
      throw new Error(value satisfies never);
  }
}
